"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCatalogCardInformation = exports.formatWeiToAssetCardEther = exports.getAssetListingsRangeInfoText = exports.getIsMintPriceInRange = exports.getListingsRangePrice = exports.getAlsoAvailableForMintingText = void 0;
const react_1 = __importDefault(require("react"));
const ethers_1 = require("ethers");
const schemas_1 = require("@dcl/schemas");
const formatter = Intl.NumberFormat('en', { notation: 'compact' });
function getAlsoAvailableForMintingText(asset, text) {
    return (react_1.default.createElement("span", null,
        text,
        ":\u00A0",
        formatWeiToAssetCardEther(asset.price)));
}
exports.getAlsoAvailableForMintingText = getAlsoAvailableForMintingText;
function getListingsRangePrice(asset) {
    return `${asset.minListingPrice} - ${asset.maxListingPrice}`;
}
exports.getListingsRangePrice = getListingsRangePrice;
function getIsMintPriceInRange(asset, appliedFilters) {
    return ((!appliedFilters.minPrice ||
        ethers_1.BigNumber.from(asset.price).gte(ethers_1.ethers.utils.parseUnits(appliedFilters.minPrice))) &&
        (!appliedFilters.maxPrice ||
            ethers_1.BigNumber.from(asset.price).lte(ethers_1.ethers.utils.parseUnits(appliedFilters.maxPrice))));
}
exports.getIsMintPriceInRange = getIsMintPriceInRange;
function getAssetListingsRangeInfoText(asset, translations) {
    return asset.minListingPrice && asset.maxListingPrice ? (react_1.default.createElement("span", { className: 'wrapBigText' },
        asset.listings,
        "\u00A0",
        asset.listings === 1 ? translations.listing : translations.listings,
        ":\u00A0",
        react_1.default.createElement("span", null,
            formatWeiToAssetCardEther(asset.minListingPrice),
            "\u00A0",
            !!asset.listings &&
                asset.listings > 1 &&
                asset.minListingPrice !== asset.maxListingPrice &&
                `- ${formatWeiToAssetCardEther(asset.maxListingPrice)}`))) : null;
}
exports.getAssetListingsRangeInfoText = getAssetListingsRangeInfoText;
function formatWeiToAssetCardEther(wei) {
    const maximumFractionDigits = 2;
    const value = Number(ethers_1.ethers.utils.formatEther(wei));
    if (value === 0) {
        return '0';
    }
    const fixedValue = value.toLocaleString(undefined, {
        maximumFractionDigits
    });
    if (fixedValue === '0') {
        return Math.pow(10, -maximumFractionDigits).toString();
    }
    return formatter.format(value);
}
exports.formatWeiToAssetCardEther = formatWeiToAssetCardEther;
function getCatalogCardInformation(asset, translations, appliedFilters = {}) {
    var _a, _b, _c, _d, _e, _f;
    const { sortBy = schemas_1.CatalogSortBy.CHEAPEST } = appliedFilters;
    const isAvailableForMint = asset.isOnSale && asset.available > 0;
    const hasListings = asset.listings && asset.listings > 0;
    const hasOnlyListings = hasListings && !isAvailableForMint;
    const hasOnlyMint = isAvailableForMint && !hasListings;
    const notForSale = !isAvailableForMint && !hasListings;
    const hasRangeApplied = !!appliedFilters.minPrice || !!appliedFilters.maxPrice;
    if (notForSale) {
        return {
            action: translations.not_for_sale,
            actionIcon: null,
            price: null,
            extraInformation: null
        };
    }
    if (sortBy === schemas_1.CatalogSortBy.CHEAPEST) {
        const info = {
            action: hasRangeApplied
                ? translations.cheapest_option_range
                : translations.cheapest_option,
            actionIcon: null,
            price: (_a = asset.minPrice) !== null && _a !== void 0 ? _a : null,
            extraInformation: null
        };
        if (hasOnlyMint) {
            info.extraInformation = null;
        }
        else if (hasOnlyListings && asset.listings && asset.listings > 1) {
            info.extraInformation = getAssetListingsRangeInfoText(asset, translations);
        }
        else {
            // has both minting and listings
            if (hasRangeApplied) {
                info.price = (_b = asset.minPrice) !== null && _b !== void 0 ? _b : asset.price;
                if (appliedFilters.minPrice) {
                    const isMintingLessThanMinPriceFilter = ethers_1.BigNumber.from(asset.price).lt(ethers_1.ethers.utils.parseUnits(appliedFilters.minPrice));
                    info.extraInformation = isMintingLessThanMinPriceFilter
                        ? getAlsoAvailableForMintingText(asset, translations.available_for_mint)
                        : null;
                }
            }
            else {
                const mintIsNotCheapestOption = ethers_1.BigNumber.from(asset.price).gt(ethers_1.BigNumber.from(asset.minPrice));
                if (mintIsNotCheapestOption) {
                    info.extraInformation = getAlsoAvailableForMintingText(asset, translations.available_for_mint);
                }
            }
        }
        return info;
    }
    else if (sortBy === schemas_1.CatalogSortBy.MOST_EXPENSIVE) {
        const info = {
            action: hasRangeApplied
                ? translations.most_expensive_range
                : translations.most_expensive,
            actionIcon: null,
            price: asset.price,
            extraInformation: getAssetListingsRangeInfoText(asset, translations)
        };
        const isMintingGreaterThanMaxListingPrice = !!asset.maxListingPrice &&
            ethers_1.BigNumber.from(asset.price).gt(ethers_1.BigNumber.from(asset.maxListingPrice));
        info.price =
            getIsMintPriceInRange(asset, appliedFilters) &&
                isMintingGreaterThanMaxListingPrice
                ? asset.price
                : (_c = asset.maxListingPrice) !== null && _c !== void 0 ? _c : asset.price;
        return info;
    }
    // rest of filter without label logic
    const info = {
        action: '',
        actionIcon: null,
        price: asset.price,
        extraInformation: null
    };
    if (hasOnlyMint) {
        info.action = translations.available_for_mint;
        info.actionIcon = 'mintingIcon';
    }
    else if (hasOnlyListings) {
        info.action = hasRangeApplied
            ? translations.available_listings_in_range
            : translations.cheapest_listing;
        info.price =
            asset.listings &&
                asset.listings > 1 &&
                asset.minListingPrice !== asset.maxListingPrice
                ? hasRangeApplied
                    ? getListingsRangePrice(asset)
                    : (_d = asset.minListingPrice) !== null && _d !== void 0 ? _d : ''
                : (_e = asset.minPrice) !== null && _e !== void 0 ? _e : '';
    }
    else {
        // both mint and listings available
        if (hasRangeApplied) {
            const isMintInRange = getIsMintPriceInRange(asset, appliedFilters);
            info.action = isMintInRange
                ? translations.available_for_mint
                : translations.available_listings_in_range;
            info.price = isMintInRange ? asset.price : (_f = asset.minListingPrice) !== null && _f !== void 0 ? _f : '';
            info.actionIcon = isMintInRange ? 'mintingIcon' : null;
            info.extraInformation = isMintInRange
                ? getAssetListingsRangeInfoText(asset, translations)
                : null;
            if (appliedFilters.minPrice) {
                const isMintingLessThanMinPriceFilter = ethers_1.BigNumber.from(asset.price).lt(ethers_1.ethers.utils.parseUnits(appliedFilters.minPrice));
                info.extraInformation =
                    !isMintInRange && isMintingLessThanMinPriceFilter
                        ? getAlsoAvailableForMintingText(asset, translations.available_for_mint)
                        : info.extraInformation;
            }
        }
        else {
            // mint is the cheapest, show "available for mint" and the listings range
            info.action = translations.available_for_mint;
            info.actionIcon = 'mintingIcon';
            info.extraInformation = getAssetListingsRangeInfoText(asset, translations);
        }
    }
    return info;
}
exports.getCatalogCardInformation = getCatalogCardInformation;
//# sourceMappingURL=utils.js.map